import { render, staticRenderFns } from "./RecoverPasswordForm.vue?vue&type=template&id=5009525e"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports